import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { logError } from "@/lib/logger";

// Capture uncaught runtime errors so they appear in Admin → Logs
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    logError(event.error ?? new Error(event.message), "Window Error", {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    logError(event.reason ?? new Error("Unhandled promise rejection"), "Unhandled Rejection");
  });
}

createRoot(document.getElementById("root")!).render(<App />);

